import { createHashHistory } from 'history';

export const history = createHashHistory({
  basename: '/',
});

export default history;
